import { render, staticRenderFns } from "./FirstVisit.vue?vue&type=template&id=0588acea&scoped=true&"
import script from "./FirstVisit.vue?vue&type=script&lang=js&"
export * from "./FirstVisit.vue?vue&type=script&lang=js&"
import style0 from "./FirstVisit.vue?vue&type=style&index=0&id=0588acea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588acea",
  null
  
)

export default component.exports